module.exports = "<div class=\"spinner-container\">\n  <mat-spinner></mat-spinner>\n</div>\n"